<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.xiao_xi_ming_cheng')">
              <el-input v-model="form.triggerCodeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.xiao_xi_lei_xing')">
              <custom-select v-model="form.msgType" code="bas_msg_type" :placeholder="$t('Common.com_please_select')" disabled></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.tui_song_jue_se')">
              <el-row>
                <el-col>{{ form.pushRange }}</el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.tui_song_fan_wei')">
              <el-row>
                <el-col>{{ form.pushRole }}</el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.tui_song_qu_dao')">
              <el-row>
                <el-col>{{ form.pushChannel }}</el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.xiao_xi_mu_ban')">
              <custom-select
                v-model="form.templGroupId"
                :disabled="true"
                :placeholder="$t('Common.com_please_select')"
                :props="{
                  label: 'name',
                  value: 'value',
                  checkStrictly: true
                }"
                url="MsgTemplateGroupTree"
                type="tree"
                :show-all-levels="false"
                :params="{}"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.chuang_jian_shi_jian')">
              <el-row>{{ form.gmtCreate }}</el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_content_dialog.chuang_jian_ren')">
              <el-row>{{ form.creator }}</el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        triggerCodeName: '',
        msgType: '',
        pushRange: '',
        pushRole: '',
        pushChannel: '',
        templGroupId: null,
        creato: '',
        gmtCreate: ''
      }
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.getDictionary('spring_cloud_msg_fault_grade,bas_msg_type');
      this.form.appId = this.model.data.appId; // 所属应用
      if (this.model.type === 'see') {
        this.form.triggerCodeName = this.model.data.triggerCodeName;
        this.form.msgType = `${this.model.data.msgType}`; //
        this.form.pushRange = this.model.data.pushRangeName;
        this.form.pushRole = this.model.data.pushRoleName;
        this.form.pushChannel = this.model.data.pushChannelName;
        this.form.templGroupId = this.model.data.templGroupId; // 接口 配合多级下拉
        this.form.creator = this.model.data.creator;
        this.form.gmtCreate = this.model.data.gmtCreate;
      }
    }
  }
};
</script>

<style lang="scss"></style>
